import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

const sizes: Record<string, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-3',
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'md', label = 'Loading' }) => (
  <div className="flex flex-col items-center justify-center gap-4" role="status" aria-label={label}>
    <div className={`animate-spin rounded-full ${sizes[size]} border-stone-900 border-t-transparent`} />
    <span className="sr-only">{label}</span>
  </div>
);

export default LoadingSpinner;
